<template>
    <!-- 中奖名单轮播 -->
    <div :key="winnerList.length"
        class="award-list"
        :style="getItemStyle">
        <div id="scrollBox"
            style="position: relative;">
            <div v-for="(item, index) in winnerList"
                :key="index + 0"
                class="award-list-item">
                <div class="award-list-item-options">
                    <img v-if="item.userHeadPortraitUrl"
                        :src="item.userHeadPortraitUrl">
                    <img v-else
                        src="static/runtime/images/magic/award/userImg.png">
                    <div class="ellipsis">{{ item.nickName }}</div>
                </div>
                <div class="award-list-item-options ellipsis">
                    <div v-if="item.rewardType == '4'">{{ item.pointValue }}积分</div>
                    <div v-else>{{ item.rewardName }}</div>
                </div>
                <div class="award-list-item-options ellipsis">{{ item.creationDateStr }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    activityObj: Object,
    winnerList: Array,
    tigerLottery: Boolean,
  },
  computed: {
    getItemStyle() {
      return {
        color: (this.activityObj && this.activityObj.scrollWordsColor) || '#333',
      };
    },
  },
  data() {
    return {
      timeTimeout: '',
      timeInterval: '',
    };
  },
  watch: {
    winnerList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // 中奖数超过指定数量，且开启了滚动
        // prizeWinningScrollFlag 1: '按全量的中奖展示', 0: '按中奖滚动展示'
        if (newVal && newVal.length > 0 && newVal.length > this.activityObj.prizeWinningNumbers && this.activityObj.prizeWinningScrollFlag === 0) {
          this.$nextTick(() => {
            clearInterval(this.timeInterval);
            clearTimeout(this.timeTimeout);
            this.horseRaceLamp('scrollBox');
          });
        }
      },
    },
  },
  methods: {
    // 滚动栏动画
    horseRaceLamp(id) {
      const area = document.getElementById(id);
      // 为空则不进行后续操作
      if (!area) {
        return;
      }
      const lHeight = 60;
      const time = 50;
      // 滚动停留时间
      const scrollStaySeconds = this.activityObj.scrollStaySeconds ? this.activityObj.scrollStaySeconds * 1000 : 0;

      area.innerHTML += area.innerHTML;
      area.style.top = '0px';
      // console.log("赋值");
      const scrollHeight = area.scrollHeight;
      // 移动速度
      const scrollMove = () => {
        area.style.top = parseInt(area.style.top) - 3 + 'px';
        this.timeInterval = setInterval(scrollUp, time);
      };
      const scrollUp = () => {
        if (parseInt(area.style.top) % lHeight == 0) {
          // console.log("停一次", area.style.top, scrollHeight);
          clearInterval(this.timeInterval);
          this.timeTimeout = setTimeout(scrollMove, scrollStaySeconds);
        } else {
          area.style.top = parseInt(area.style.top) - 3 + 'px';
          if (Math.abs(parseInt(area.style.top)) >= scrollHeight / 2) {
            //判断滚动高度,当滚动高度大于area本身的高度时，使其回到原点重新滚动
            // console.log("比较");
            area.style.top = '0px';
          }
        }
      };
      scrollMove();
    },
  },
};
</script>
<style lang="scss" scoped>
.award-list {
  background: rgba(255, 255, 255, 0.2);
  max-height: 58px;
  width: 100%;
  margin: auto 0;
  pointer-events: none;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .award-list-item {
    width: 100%;
    padding: 10px 10px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    pointer-events: none;

    .award-list-item-options {
      font-size: 14px;
      pointer-events: none;
      margin-right: 10px;
      line-height: 42px;

      img {
        display: inline;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 5px;
      }

      div {
        display: inline;
        white-space: nowrap;
      }
    }

    .award-list-item-options:nth-child(1) {
      max-width: 30%;
      display: flex;
    }

    .award-list-item-options:nth-child(2) {
      text-align: center;
      max-width: 50%;
    }

    .award-list-item-options:nth-child(3) {
      max-width: 20%;
      min-width: 80px;
      margin-right: 0;
      text-align: right;
    }
    .ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/winner-list.vue